import { EmptyState } from './EmptyState';

export function DataTable({ columns, rows, empty }) {
  if (!rows.length) return empty || <EmptyState title="No records yet" message="Create your first item to get started." />;

  return (
    <div className="table-shell">
      <table>
        <thead>
          <tr>
            {columns.map((column) => <th key={column.key}>{column.label}</th>)}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.id}>
              {columns.map((column) => (
                <td key={column.key}>{column.render ? column.render(row) : row[column.key]}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
